import { AppTooltip } from '@components'
import { ChartSpline, Image } from 'lucide-solid'
import { useService } from 'solid-services'
import { type ListLayout, useList } from '../state'
import { segButton, segTrack } from './segStyles'

export const LayoutSelector = () => {
  const { activeLayout, setActveLayout } = useService(useList)()

  return (
    <div
      role="group"
      aria-label="Card content"
      class={segTrack}
    >
      <AppTooltip
        delay={900}
        content='Setups Gallery view'
      >
        <button
          type="button"
          aria-pressed={activeLayout() === 'image'}
          class={segButton(activeLayout() === 'image')}
          onClick={() => setActveLayout('image')}
        >
          <Image size={16} />
        </button>
      </AppTooltip>

      <AppTooltip
        delay={900}
        content='Setups Wireframe view'
      >
        <button
          type="button"
          aria-pressed={activeLayout() === 'noramlised'}
          class={segButton(activeLayout() === 'noramlised')}
          onClick={() => setActveLayout('noramlised')}
        >
          <ChartSpline size={16} />
        </button>
      </AppTooltip>
    </div>
  )
}
